export default __webpack_public_path__ + "static/media/it.b4b18a02.jpg";